module.exports = __webpack_public_path__ + "static/logo-blue-laval-26b88e8a6e2edd4ced9b12c536e73d87.png";